import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgHeartSolid from '../../svg/heart-solid.svg'
import { IconProps } from '../icon-props'

const HeartSolidIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgHeartSolid
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-heartsolid', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default HeartSolidIcon
